document.addEventListener('DOMContentLoaded', function() {
    checkAndUpdateCart();
});

async function checkAndUpdateCart() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        console.log(cart);

        const variantA = 52024487346468; // Bundle product
        const variantB = 52007899037988; // Single product

        const variantAItems = cart.items.filter(
            item => item.variant_id === variantA
        );

        const variantBItems = cart.items.filter(
            item => item.variant_id === variantB
        );

        console.log('Variant A Items:', variantAItems);
        console.log('Variant B Items:', variantBItems);

        // -----------------------------------
        // RULE 1:
        // Keep ONLY 1 total quantity of variantA
        // across all line items
        // -----------------------------------

        let quantityToKeep = 1;

        for (const item of variantAItems) {

            if (quantityToKeep > 0) {

                // Keep only remaining allowed quantity
                const allowedQty = Math.min(item.quantity, quantityToKeep);

                if (item.quantity !== allowedQty) {
                    await removeVariantFromCart(item.key, 1);
                }

                quantityToKeep -= allowedQty;

            } else {

                // Remove extra line items
                await removeVariantFromCart(item.key, 0);
            }
        }

        // -----------------------------------
        // RULE 2:
        // If variantA exists, remove ALL variantB
        // -----------------------------------

        if (variantAItems.length > 0) {

            for (const item of variantBItems) {
                await removeVariantFromCart(item.key, 0);
            }

            console.log('Removed all variantB items because variantA exists');
        }

    } catch (error) {
        console.error('Error handling cart:', error);
    }
}

function removeVariantFromCart(cartItemId) {
    console.log("Attempting to remove cart item with ID:", cartItemId);
  
    // Send a POST request to Shopify's cart/change.js to remove the variant
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            id: cartItemId, // Use the cart item ID
            quantity: 0  // Setting quantity to 0 will remove the variant
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log(`Cart item with ID ${cartItemId} removed from the cart.`);
    })
    .catch(error => {
        console.error('Error removing variant from cart:', error);
    });
}

function updateCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      console.log('Cart updated:', cart);
      // Optionally, update the cart display or refresh the cart drawer here
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}